import {useMemo, useState} from "react";
import {GeofenceEntity} from "@ots-frontend/ots-data";
import {useDebouncedValue} from "@mantine/hooks";
import {
  DataTableFilterConfig,
  useDataTableFilter,
  UseDataTableFilterProps,
  UseDataTableFilterResult
} from "../DataTable/useDataTableFilter";
import {useTranslation} from "react-i18next";

export type UseGeofenceDataTableFilterProps = Omit<UseDataTableFilterProps<GeofenceEntity>, 'filterConfig'>

export function useGeofenceDataTableFilter(props: UseGeofenceDataTableFilterProps): UseDataTableFilterResult<GeofenceEntity> {
  const {records} = props;

  const {t} = useTranslation(["common"])

  const filterConfig: DataTableFilterConfig<GeofenceEntity> = useMemo(() => {
    return {

    }
  }, [
    t
  ])

  const {filteredRecords} = useDataTableFilter({
    records: records,
    filterConfig: filterConfig,
  })

  return {
    filteredRecords: filteredRecords,
    filterConfig: filterConfig
  };
}
